// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"64":"editEvent","594":"inspiration"}[chunkId] + "." + {"64":"bc9d7152c72ea4b8faa4","594":"979c323dc4cfe266ebb8"}[chunkId] + ".bundle.js";
};